import { Transaction } from 'components/TransactionAllocator';
import { CalendarDay } from 'further-ui/utils';
import { TransactionOperation } from 'further-types/lp/transaction';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { useCapitalActionsTransactions } from './useCapitalActionsTransactions';

type AdvanceSubscriptionTransaction = {
  actionId: string;
  name: string;
  ledgerDate: CalendarDay;
  transactionTypeId: string;
  transactionSubType: string;
  operationType: TransactionOperation;
  amountIncVatTcy: number;
  amountExVatTcy: number;
  amountIncVatLcy: number;
  amountExVatLcy: number;
  commitmentId: string;
  label?: string;
  effectiveCapitalDate?: CalendarDay;
};

type UseAdvanceSubscriptionsTransactionsProps = {
  advanceSubscriptionsTransactions: Array<AdvanceSubscriptionTransaction>;
  baseCurrency: CurrencyCode;
  savedTransactions?: Record<string, Array<Transaction>>;
};

const useAdvanceSubscriptionsTransactions = ({
  advanceSubscriptionsTransactions,
  baseCurrency,
  savedTransactions,
}: UseAdvanceSubscriptionsTransactionsProps) => {
  return useCapitalActionsTransactions({
    capitalActionsTransactions: advanceSubscriptionsTransactions,
    baseCurrency,
    savedTransactions,
  });
};

export default useAdvanceSubscriptionsTransactions;
